import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const globalTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      toast: {
        primary: {
          background: theme.color.focus[6],
          text: theme.color.text.core['-primary'],
          border: theme.color.focus[4],
        },
        error: {
          background: theme.color.dataVis.qualitative['magenta-1'] + '20',
          text: theme.color.dataVis.qualitative['magenta-2'],
          border: theme.color.dataVis.qualitative['magenta-3'] + '40',
        },
      },
    },
  ]),
);
